import { render, staticRenderFns } from "./KioskFooter.vue?vue&type=template&id=0c08ce78&scoped=true"
import script from "./KioskFooter.vue?vue&type=script&lang=js"
export * from "./KioskFooter.vue?vue&type=script&lang=js"
import style0 from "./KioskFooter.vue?vue&type=style&index=0&id=0c08ce78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c08ce78",
  null
  
)

export default component.exports